import { onMaintenance, isUserAuthenticated } from '../util';

const Login = () => import(/* webpackPrefetch: true */ '@/pages/oauth/Login');
const PasswordRecovery = () => import(/* webpackChunkName: "accounts" */ '@/pages/oauth/PasswordRecovery');
const NewPassword = () => import(/* webpackChunkName: "accounts" */ '@/pages/oauth/NewPassword');
const CreateAccount = () => import(/* webpackChunkName: "accounts" */ '@/pages/onboarding');
const PaymentRedirect = () => import(/* webpackChunkName: "accounts" */ '@/pages/paymentRedirect');

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (onMaintenance()) next('/maintenance');
      else if (isUserAuthenticated()) next('/');
      else next();
    },
  },
  {
    path: '/passwordRecovery',
    name: 'passwordRecovery',
    component: PasswordRecovery,
    beforeEnter: (to, from, next) => {
      if (isUserAuthenticated()) next('/');
      else next();
    },
  },
  {
    path: '/newPassword',
    name: 'newPassword',
    component: NewPassword,
    beforeEnter: (to, from, next) => {
      if (isUserAuthenticated()) next('/');
      else next();
    },
  },
  {
    path: '/signup',
    name: 'Create account',
    component: CreateAccount,
    beforeEnter: (to, from, next) => {
      if (isUserAuthenticated()) next('/');
      else next();
    },
  },
  {
    path: '/paymentRedirect',
    name: 'paymentRedirect',
    component: PaymentRedirect,
  },
];
